export * from './sidenav.component';
export * from './sidenav.module';



// WEBPACK FOOTER //
// ./src/app/typescripts/pro/sidenav/index.ts